import React, { useEffect, useRef } from 'react'
import { 
    useSelector,
    useDispatch
} from 'react-redux'
import { useNavigate, useLocation } from 'react-router'
import { Radio } from "antd";

// Constants
import { 
    TEMPLATE,
    ROUTES, 
    COMMON_FEATURES 
} from '../../constants'

// Components
import showSecondarySidebar from '../../layout/MainLayout/helpers/showSecondarySidebar' 
import Page from "../../components/Decoration/Page"

// Panel
import DevicePanel from './components/DevicePanel'
import DriverPanel from '../DriverManagement/module/DriverPanel'
// import NotificationPanel from './components/NotificationPanel'
import RuleEnginePanel from './components/RuleEnginePanel'
import VehiclePanel from '../VehicleManagement/modules/VehiclePanel'
import VehicleGroupPanel from '../VehicleManagement/modules/VehicleGroupPanel'
import LiveTrackingPanel from './components/LiveTrackingPanel';
// import RouteManagementPanel from '../RouteManagement/modules/RouteManagementPanel';

// Service
import { v3_userHierarchy } from '../../services/redux/actions';

const PANELS = {
    vehicle: {
        label: 'Vehicles',
        key: 'vehicle',
        value: COMMON_FEATURES.FEATURE_NAME.VEHICLE_MANAGEMENT,
        component: <VehiclePanel />,
    },
    driver: {
        label: 'Drivers',
        key: 'driver',
        value: COMMON_FEATURES.FEATURE_NAME.DRIVER_MANAGEMENT,
        component: <DriverPanel />,
    },
    vehicleGroup: {
        label: 'Vehicle Group',
        key: 'vehicleGroup',
        value:  COMMON_FEATURES.FEATURE_NAME.VEHICLE_GROUP_MANAGEMENT,
        component: <VehicleGroupPanel />
    },
    gps: {
        label: 'GPS',
        key: 'gps',
        value:  COMMON_FEATURES.FEATURE_NAME.GPS_MANAGEMENT,
        component: <DevicePanel />,
        hiddenFrom: [TEMPLATE.USER_ROLE.ROLE_TYPE.FLEET_OWNER , TEMPLATE.USER_ROLE.ROLE_TYPE.FLEET_MANAGER, TEMPLATE.USER_ROLE.ROLE_TYPE.FLEET_OPERATOR]
    },
    mdvr: {
        label: 'MDVR',
        key: 'mdvr',
        value:  COMMON_FEATURES.FEATURE_NAME.MDVR_MANAGEMENT,
        component: <DevicePanel />,
        hiddenFrom: [TEMPLATE.USER_ROLE.ROLE_TYPE.FLEET_OWNER , TEMPLATE.USER_ROLE.ROLE_TYPE.FLEET_MANAGER, TEMPLATE.USER_ROLE.ROLE_TYPE.FLEET_OPERATOR]
    },
    // route: {
    //     label: 'Route Management',
    //     key: 'route',
    //     value:  COMMON_FEATURES.FEATURE_NAME.ROUTE_MANAGEMENT,
    //     component: <RouteManagementPanel />,
    // },
    rule: {
        label: 'Rule Engine',
        key: 'rule',
        value: COMMON_FEATURES.FEATURE_NAME.RULE_ENGINE_MANAGEMENT,
        component: <RuleEnginePanel />,
    },
    // notification: {
    //     label: 'Notification',
    //     key: 'notification',
    //     value: COMMON_FEATURES.FEATURE_NAME.NOTIFICATION_MANAGEMENT,
    //     component: <NotificationPanel />,
    // },
    livetracking: {
        label: 'Live Tracking Link',
        key: 'livetracking',
        value: COMMON_FEATURES.FEATURE_NAME.LIVE_TRACK_LINK,
        component: <LiveTrackingPanel />,
    },
}

const OverallManagementPanel = () => {

    const navigate = useNavigate()
    const routerLocation = useLocation()
    const dispatch = useDispatch()

    const curUserRole = useSelector(state => state.containers.v3.user && state.containers.v3.user.uroleid)
    const user = useSelector(state => state.containers.v3.user)
    const userHierarchyTree = useSelector(state => state.containers.v3.userHierarchy.hierarchyTree)

    const onChangeTableTab = (e) => {
        navigate(ROUTES.MODULE_ROUTE[e.target.value])
    }

    let tab = routerLocation.pathname.split('/').pop()

    if (!PANELS[tab] || tab === 'overall') {
        tab = PANELS.vehicle.key
    }

    const isLoad = useRef(false)

    useEffect(() => {
        if(user.uid && !isLoad.current && !Object.keys(userHierarchyTree).length) {
            dispatch(v3_userHierarchy.user_hierarchy_get_request(user, user.hierCode))
            isLoad.current = true
        }
    }, [user.uid])

    return (
        <div className="page-container">
            <Page title="Overall Management">
                <Radio.Group value={PANELS[tab].value} buttonStyle="solid" onChange={onChangeTableTab}>
                    {
                        Object.values(PANELS)
                            .filter(panel => {
                                if (!curUserRole) return false
                                if (!panel.hiddenFrom) return true
                                return !panel.hiddenFrom.includes(curUserRole)
                            })
                            .map(panel =>
                                <Radio.Button key={panel.key} value={panel.value}>
                                    {panel.label}
                                </Radio.Button>
                            )
                    }
                </Radio.Group>

                <div style={{ marginTop: 30 }}>
                    {
                        PANELS[tab] && PANELS[tab].component
                    }
                </div>
            </Page>
        </div>
    )
}

const MemorizedOverallManagementPanel = React.memo(OverallManagementPanel);

export default showSecondarySidebar(false)(MemorizedOverallManagementPanel);